module.exports = __webpack_public_path__ + "static/img/px2.37e8f475.jpg";